import { useQuery } from "@tanstack/react-query";
import { useFeatureFlagEnabled } from "posthog-js/react";

import { NEW_BANKING_ACCOUNTS_PAGE_FLAG } from "../components/constants";
import { shouldShowNewAccountsPage } from "../pages/banking/should-show-new-accounts-page";
import { groupedBankingSourcesQueryOptions } from "../queries/bank-connect/queries";

export const useShouldShowNewAccountsPage = (customerDomain: string, enabled: boolean): boolean => {
  const newAccountsPageEnabled = useFeatureFlagEnabled(NEW_BANKING_ACCOUNTS_PAGE_FLAG) === true;
  const { data: groupedSources } = useQuery({ ...groupedBankingSourcesQueryOptions(customerDomain), enabled });

  return groupedSources ? shouldShowNewAccountsPage(newAccountsPageEnabled, groupedSources) : false;
};
